<template>
  <placeholder-screen title="Current Focus">
    <p class="text-left">
      After your strength analysis is complete, it’s time for you to choose the direction for your personal growth
      journey. </p>
    <p class="text-left">
      We’ll give you the guidance for your focused improvement, but you’re in the driver’s seat.  This screen
      will track your progress, provide the next steps, and help you reach one new level after another.
    </p>
    <p>
      This feature will be available as part of the <em>Grow</em> release in January.
    </p>
  </placeholder-screen>
</template>
<script>
  import { mapActions } from 'vuex';
  import PlaceholderScreen from '../UIComponents/PlaceholderScreen.vue';
 
  export default {
    created() {
      this.setNavbarTitle('Current Focus');
    },
    methods: {
      ...mapActions('UI', ['setNavbarTitle']),
    },
    components: {
      PlaceholderScreen
    }
  }

</script>
<style>

</style>
